export const Edit = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.6191 2.66687H4.66699C3.56246 2.66687 2.66706 3.56236 2.66699 4.66687V15.3339C2.66734 16.4381 3.56264 17.3339 4.66699 17.3339H15.334C16.438 17.3335 17.3336 16.4379 17.334 15.3339V7.37976L19.334 5.37976V15.3339C19.3336 17.5425 17.5426 19.3335 15.334 19.3339H4.66699C2.45807 19.3339 0.667344 17.5427 0.666992 15.3339V4.66687C0.667058 2.45779 2.45789 0.66687 4.66699 0.66687H14.6191L12.6191 2.66687ZM19.5117 2.84558L9.51172 12.8456L6.66699 13.3329L7.15527 10.4882L17.1553 0.488159L19.5117 2.84558Z"
      fill="currentColor"
    />
  </svg>
)
